<template>
  <div class="info-row">
    <div class="label" :style="{ width: labelWidth + 'px' }">
      <slot name="label">{{ label }}</slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "info-row",
  props: {
    label: [String, Number],
    labelWidth: {
      type: [String, Number],
      default: "64"
    }
  }
}
</script>

<style lang="scss" scoped>
.info-row {
  display: flex;
  margin-bottom: 20px;
  .label {
    margin-right: 20px;
  }
  .content {
    flex: 1 1;
  }
}
</style>
